/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Set/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Assistant from './Assistant/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Set({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/SchedulingPreferences/Content/Assistants/Set"
  
}) {
let schedulingPreferencesAssistantsValueData = fromData.useDataValue({ viewPath,
context: 'scheduling_preferences',
path: 'assistants',
})
  return (<React.Fragment
>
<div
  data-testid="Set.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(schedulingPreferencesAssistantsValueData) && schedulingPreferencesAssistantsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="scheduling_preferences_assistant"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Assistant(${item?.id ?? item?._id ?? index})`}
      >
<Assistant
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Assistant(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }